import { createContext } from 'react';
import UserStore from '../store/UserStore';
import ProductStore from '../store/ProductStore';
import OrderStore from '../store/OrderStore';
import CartStore from '../store/CartStore';
import UIStore from '../store/UIStore';
import RestaurantStore from "../store/RestaurantStore";

// EN: Define the shape of our global stores object for TypeScript.
// PL: Zdefiniuj kształt naszego globalnego obiektu magazynów dla TypeScript.
export interface IStore {
  user: UserStore;
  product: ProductStore;
  order: OrderStore;
  cart: CartStore;
  ui: UIStore;
  restaurant: RestaurantStore;
}


// EN: Create a single instance of each store. These will be singletons for the app's lifecycle.
// PL: Utwórz pojedynczą instancję każdego magazynu. Będą to singletony na czas życia aplikacji.
export const stores: IStore = {
  user: new UserStore(),
  product: new ProductStore(),
  order: new OrderStore(),
  cart: new CartStore(),
  ui: new UIStore(),
  restaurant: new RestaurantStore(),
};

// EN: Link stores together for inter-store communication.
// PL: Połącz magazyny ze sobą w celu komunikacji między nimi.
stores.user.setCartStore(stores.cart);

// EN: Create the React Context. This will be used with a Provider in main.tsx
//     and with the useContext hook in components to access the stores.
// PL: Utwórz Kontekst Reacta. Będzie on używany z Providerem w main.tsx
//     oraz z hakiem useContext w komponentach, aby uzyskać dostęp do magazynów.
export const Context = createContext<IStore>(stores);

